export default {
    ca: {
        title: 'Esborrar l\'aplicació',
        message: 'Segur que vols esborrar l\'aplicació?',
        nota: 'En esborrar l\'aplicació desapareixerà tant de la teva galeria com de la pública.',
        esborrar: 'Esborrar',
        messageError: 'No s\'ha pogut esborrar l\'aplicació',
    },
    es: {
        title: 'Borrar la aplicación',
        message: 'Seguro que quieres borrar la aplicación?',
        nota: 'Al borrar la aplicación desaparecerá tanto de tu galería como de la pública.',
        esborrar: 'Borrar',
        messageError: 'No se ha podido borrar la aplicación',
    },
    en: {
        title: 'Delete the application',
        message: 'Are you sure you want to delete the application?',
        nota: 'Deleting the application will make it disappear from your gallery as well as from the public one.',
        esborrar: 'Delete',
        messageError: 'Could not delete application',
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/borrar-app-modal/borrar-app-modal-translations.js